import { useEffect, useState } from 'react';
import { AudioService } from '../audio-service';
import { RANKS, SUITS } from '../game/waterfall-poker-game';
import { getImagePath } from './PlayingCard';

type SplashProps = {
    audioSvc: AudioService;
    onLoaded: () => void;
};

let count = 0;
let ttlCount = 3; // 3 sounds

export function Splash({ audioSvc, onLoaded }: SplashProps) {
    const [percent, setPercent] = useState<number>();
    const [ready, setReady] = useState(false);
    
    useEffect(() => {
        if (percent == null) {
            setPercent(0);

            audioSvc.loadAudio(() => itemLoaded())
                .catch(err => {
                    console.error(err.message);
                });

            for (const suit of SUITS) {
                for (const rank of RANKS) {
                    ++ttlCount;
                    const img = document.createElement("img");
                    img.src = getImagePath(rank, suit);
                    img.onload = itemLoaded;
                }
            }
        }

        function itemLoaded(): void {
            if (++count >= ttlCount) {
                setPercent(100);
                setReady(true);
                onLoaded();
                console.log("done loading");
            }
            else {
                const pct = Math.round(100 * count / ttlCount);
                setPercent(pct);
            }
        }
    }, [audioSvc, percent, onLoaded]);

    return (
        <div className='splash' onClick={() => { if (ready) onLoaded() }}>
            <h1>Waterfall Poker</h1>
            {/* <img src="/images/waterfall.png" alt="Waterfall"/> */}
            {!ready &&
            <div>
                <h2>Loading...</h2>
                <progress max={100} value={percent}/>
            </div>
            }
            {ready && <h2>Tap to play</h2>}
        </div>
    );
}
